import React from 'react';
import Modal from '../../component/Inc/Modal';
function PopLeave(props) {
  const {open, close, text} = props;
  return (
    <Modal open={open} close={close} popSize="xs" type="com_input">
      <div className="content_container scroll">
        <div className="pop_cont">{text}</div>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">확인</button>
      </div>
    </Modal>
  );
}

export default PopLeave;
